import { Button } from "antd";
import React, { useEffect, useState } from "react";
import { HelperContext } from "store/helperStore";
import pause from "../../../assets/img/icons/pauseIcon.svg";
import play from "../../../assets/img/icons/playIcon.svg";
import placeholderIcon from "../../../assets/img/placeholderIcon.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "./testQues.scss";

export default function TestQues({ type, question }) {
  console.log("questionquestion", question);
  const [myQues, setMyQues] = useState(question);
  const { helperC } = HelperContext();
  useEffect(() => {
    setMyQues(question);
    return () => setMyQues("");
  }, [question]);

  const {
    que_hint,
    que_title1,
    link1,
    link1_type,
    que_title2,
    link2,
    link2_type,
    section_name,
    replay,
    info_audio,
    test_format,
  } = myQues;

  const isFNMathTest = test_format === "dummy-test";
  console.log("test_format", isFNMathTest);
  console.log("test_format", test_format);
  // const withQuesHint = question.section_name !== "MEMORY RECALL";

  // shows how the question will looks
  const getImg = (src, isBig) => {
    return (
      <LazyLoadImage
        beforeLoad={() => "Loading..."}
        placeholderSrc={placeholderIcon}
        alt=""
        effect="blur"
        src={helperC.testTempModal ? src : ""}
      />
    );
  };

  const handleQuestionPortion1And2 = (
    que_title,
    link,
    link_type,
    bigger = false
  ) => {
    console.log("que_title", que_title);
    // console.log("que_title", que_title2);

    if (que_title || link) {
      if (bigger) {
        console.log("que_title", que_title);
        //que_title1 has to be bold
        return que_title ? (
          <>
            {replay === "Y" && (
              <p className="" dangerouslySetInnerHTML={{ __html: que_title }} />
            )}
          </>
        ) : link_type === "image" ? (
          <div className="test-ques-img">{getImg(link, false)}</div>
        ) : link_type === "big-image" ? (
          <div className="multi-tap-ques-img">{getImg(link, true)}</div>
        ) : replay === "Y" ? (
          <>
            <AudioClip URL={link} timerControl={false} />
          </>
        ) : (
          <AudioClip URL={link} timerControl={true} />
        );
      } else {
        // console.log("que_title", que_title);
        return (
          <>
            {!!que_title ? (
              <>
                {console.log("que_title", que_title)}
                {replay === "Y" ? ( // replay y is in audio test
                  <p
                    className={isFNMathTest ? "FNMathTest" : ""}
                    dangerouslySetInnerHTML={{ __html: que_title }}
                  ></p>
                ) : (
                  <p
                    className={isFNMathTest ? "FNMathTest" : ""}
                    dangerouslySetInnerHTML={{ __html: que_title }}
                  />
                )}
              </>
            ) : link_type === "image" ? (
              <div className="test-ques-img">{getImg(link, false)}</div>
            ) : link_type === "big-image" ? (
              <div className="multi-tap-ques-img">{getImg(link, true)}</div>
            ) : replay === "Y" ? (
              <>
                {console.log("linklink", link)}
                <AudioClip URL={link} timerControl={false} />
              </>
            ) : (
              <>
                <AudioClip URL={link} timerControl={true} />
              </>
            )}
          </>
        );
      }
    } else {
      return null;
    }
  };

  return (
    <>
      {test_format === "listen_sound_differ" ? (
        <>
          <div className="soundDiff">
            <div className="soundDiff-audio-clip">
              <AudioClip
                URL={
                  // ""
                  require(`../../../soundDiff/${que_title1.toLowerCase()}.mp3`)
                  // .default
                }
                timerControl={false}
                replay={true}
              />
              <AudioClip
                URL={
                  require(`../../../soundDiff/${que_title2.toLowerCase()}.mp3`)
                  // .default
                }
                timerControl={false}
                replay={true}
              />
            </div>
            <h3 className="">Are the words spoken...?</h3>
          </div>
        </>
      ) : (
        <>
          <div className="question-format-one">
            {handleQuestionPortion1And2(que_title1, link1, link1_type)}
          </div>

          <div className="question-format-two">
            {handleQuestionPortion1And2("", link2, link2_type, true)}
          </div>
          {que_title2 && (
            <div className="question-format-two">
              <p
                style={{
                  fontSize: "18px",
                  fontWeight: "bold",
                }}
                className={isFNMathTest ? "FNMathTest" : ""}
                dangerouslySetInnerHTML={{ __html: que_title2 }}
              />
            </div>
          )}
        </>
      )}
    </>
  );
}

const AudioClip = ({ URL, isAudioEnded }) => {
  const [playing, toggle] = useAudio(URL);
  return (
    <Button
      onClick={toggle}
      className={`audio-player ${isAudioEnded && "disabled"}`}
    >
      {playing ? (
        <img src={pause} alt="" className="pause-icon" />
      ) : (
        <img src={play} alt="" className={`play-icon`} />
      )}
    </Button>
  );
};

const useAudio = (url) => {
  // console.log("URLURL", url);
  const { helperC } = HelperContext();
  const [audio, setAudio] = useState(new Audio(url));
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    setAudio(new Audio(url));
  }, [url]);

  useEffect(() => {
    if (!helperC.testTempModal) {
      setPlaying(false);
    }
  }, [helperC.testTempModal]);

  // replay only allow in replay Y cases audio
  const toggle = () => {
    setPlaying(!playing);
  }; // true);

  useEffect(() => {
    // PLAYING CAN BE TRUE OR FALSE
    if (playing) {
      var playPromise = audio.play();
      if (playPromise !== undefined) {
        playPromise
          .then((_) => {
            audio.addEventListener("ended", () => {
              setPlaying(false);
            });

            audio.addEventListener("pause", () => {
              setPlaying(false);
            });
          })
          .catch((error) => {
            setPlaying(false);
            setAudio(new Audio(url));
            console.log(error);
          });
      }
    }
    !playing && audio.pause();

    return () => {
      audio.pause();
    };
  }, [playing]);

  useEffect(() => {
    setPlaying(false);
    audio.addEventListener("ended", () => {
      setPlaying(false);
    });

    audio.addEventListener("pause", () => {
      // timerControl && dispatchHelper({ type: "IS_AUDIO_ENDED", payload: true });
      setPlaying(false);
    });

    return () => {
      audio.removeEventListener("ended", () => {
        setPlaying(false);
      });
      audio.addEventListener("pause", () => {
        // timerControl &&
        //   dispatchHelper({ type: "IS_AUDIO_ENDED", payload: true });
        setPlaying(false);
      });
    };
  }, []);

  return [playing, toggle];
};
